import { Text, View } from "@react-pdf/renderer";
import ReactMarkdown, { Options } from "react-markdown";

import { styles } from "../styles";

const components: Options["components"] = {
  h1({ children }) {
    return <Text style={styles.h1}>{children}</Text>;
  },
  h2({ children }) {
    return <Text style={styles.h2}>{children}</Text>;
  },
  h3({ children }) {
    return <Text style={styles.h3}>{children}</Text>;
  },
  p({ children }) {
    return <Text style={{ marginBottom: 8 }}>{children}</Text>;
  },
  strong({ children }) {
    return <Text style={{ fontWeight: 600 }}>{children}</Text>;
  },
  b({ children }) {
    return <Text style={{ fontWeight: 600 }}>{children}</Text>;
  },
  em({ children }) {
    return <Text style={{ fontStyle: "italic" }}>{children}</Text>;
  },
  i({ children }) {
    return <Text style={{ fontStyle: "italic" }}>{children}</Text>;
  },
  ul({ children }) {
    return <View style={{ marginBottom: 8 }}>{children}</View>;
  },
  ol({ children }) {
    return <View style={{ marginBottom: 8 }}>{children}</View>;
  },
  li({ children }) {
    return (
      <View style={{ width: "100%", marginBottom: 4 }}>
        <View style={{ flexDirection: "row", width: "100%" }}>
          <Text style={{ marginRight: 4 }}>•</Text>
          <Text style={{ flex: 1 }}>{children}</Text>
        </View>
      </View>
    );
  },
  hr() {
    return (
      <View
        style={{
          borderBottomColor: "#C1C3C7",
          borderBottomWidth: 1,
          marginVertical: 8,
        }}
      />
    );
  },
};

interface PdfMarkdownProps {
  children: string;
}

export const PdfMarkdown = ({ children }: PdfMarkdownProps) => (
  <ReactMarkdown components={components}>{children}</ReactMarkdown>
);
